import { WithList } from '@bv/api/crud';

class CallCenterAiAgentApi extends WithList<AiAgentListItem> {
  public constructor(public endpoint = 'call-center/ai-agent/agents') {
    super(endpoint);
  }
}

export const callCenterAiAgentApi = new CallCenterAiAgentApi();
